<template>
  <div class="device-detail-page">
    
    <div class="overview-card">
      <div class="overview-right">
        <div class="header-card">
          <div class="header-left">
            <v-btn icon variant="flat" color="#2F59EB" @click="onBack">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <div class="header-main">
              <h2 class="device-name">{{ eBlock.eBlockName }}</h2>
              <div class="meta-row">
                <span>型号：{{ eBlock.productModel }}</span>
                <span>设备编号：{{ eBlock.sort }}</span>
                <span class="d-flex align-center flex-wrap">UUID：{{ eBlock.uuid }}
                  <v-btn v-if="eBlock.uuid" class="ml-1" size="x-small" variant="text" rounded="pill"
                    color="var(--color-success)" @click.stop="copyUuid(eBlock.uuid)">复制</v-btn>
                </span>
              </div>
            </div>
          </div>

          <div class="header-right">
            <div class="status-item">
              <!-- <span class="status-label">告警</span> -->
              <v-chip size="small" class="status-alarm" :class="alarmStatus.className">
                <Siren size="16" />{{ alarmStatus.text }}
              </v-chip>
            </div>
            <div class="status-item">
              <!-- <span class="status-label">状态</span> -->
              <v-chip size="small" :class="onlineStatus.className" class="status-pill">
                <Wifi v-if="onlineStatus.className === 'online'" size="16" />
                <WifiOff v-else size="16" />
                <span>{{ onlineStatus.text }}</span>
              </v-chip>

            </div>
          </div>
        </div>

        <v-divider color="var(--color-td-border)" opacity="1" class="my-4"></v-divider>
        <section class="data-section overview-section">
          <div class="section-title">
            <div class="section-title-left">
              <v-icon size="16" color="#62C282">mdi-checkbox-marked-circle-outline</v-icon>
              <span>状态总览</span>
            </div>
          </div>
          <div class="overview-grid">
            <!-- <DataCard class="gm-border pa-4" :title="item.label" :value="item.value" :unit="item.unit" v-for="item in overviewItems" :key="item.key" :value-style="{fontSize: 16+'px', fontWeight: 700}"></DataCard> -->
            <DataCard class="blue-bg blue-border  pa-4 flex-row-reverse" title="工作状态"
              :value="formatStatus(detailData?.eBlock?.eblock_run_st, EBlockWorkStatus)" unit=""
              :value-style="{ fontSize: 16 + 'px', fontWeight: 700 }">
              <template #icon>
                <img src="./img/ic_work_status.png" alt="ic_work_status">
              </template>
            </DataCard>
            <DataCard class="blue-bg blue-border  pa-4 flex-row-reverse" title="实时功率"
              :value="toFixedDisplay(detailData?.pcs?.p, 2)" unit="kW"
              :value-style="{ fontSize: 16 + 'px', fontWeight: 700 }"></DataCard>
            <DataCard class="red-bg red-border  pa-4 flex-row-reverse" title="SOC"
              :value="toFixedDisplay(detailData?.eBlock?.soc, 2)" unit="%"
              :value-style="{ fontSize: 16 + 'px', fontWeight: 700 }">
              <template #icon>
                <v-progress-circular :model-value="toFixedDisplay(detailData?.eBlock?.soc, 2)" :rotate="180" :size="50"
                  :width="4" color="pink">
                  <span style="font-size: 12px; font-weight: 700;">{{ toFixedDisplay(detailData?.eBlock?.soc, 2)
                  }}</span>
                </v-progress-circular>
              </template>
            </DataCard>
            <DataCard class="blue-bg blue-border pa-4 flex-row-reverse" title="SOH"
              :value="appraiseFromSOH(detailData?.eBlock?.soh)" unit=""
              :value-style="{ fontSize: 16 + 'px', fontWeight: 700 }">
              <template #icon>
                <img src="./img/ic_soh.png" alt="ic_soh">
              </template>
            </DataCard>
            <DataCard class="green-bg green-border  pa-4 flex-row-reverse" title="电池剩余电量"
              :value="toFixedDisplay(detailData?.eBlock?.e_dischargeable, 2)" unit="kWh"
              :value-style="{ fontSize: 16 + 'px', fontWeight: 700 }">
              <template #icon>
                <BatteryIcon :soc="detailData?.eBlock?.soc" />
              </template>
            </DataCard>
          </div>
        </section>
      </div>
    </div>

    <div class="d-flex overview-card">
      <div class="overview-left">
        <div class="device-image-wrap">
          <img :src="deviceImageSrc" alt="设备模型图" class="device-image" loading="lazy" />
          <div>型号：{{ eBlock.productModel }}   <a style="color: var(--color-primary);" :href="getProductIntroduce(eBlock.productModel)" target="_blank">产品介绍</a></div>
        </div>
      </div>
      <div class="section-matrix">
        <section class="data-section">
          <div class="section-title">
            <div class="section-title-left">
              <v-icon size="16" color="#4C7EFF">mdi-cog-outline</v-icon>
              <span>PCS 参数</span>
            </div>
            <button type="button" class="section-more-btn" v-ripple="{ class: 'text-indigo-lighten-4' }"
              @click="openPCSDetail()">
              详情
              <v-icon size="14" color="#4C7EFF">mdi-chevron-right</v-icon>
            </button>
          </div>
          <div class="section-grid">
            <!-- <div v-for="item in pcsItems" :key="item.key" class="kv-item">
              <span class="kv-label">{{ item.label }}</span>
              <span class="kv-value">{{ item.value }}</span>
            </div> -->
            <DataCard class="kv-bg" :title="item.label" title-position="left" :value="item.value" :unit="item.unit"
              v-for="item in pcsItems" :key="item.key" :value-style="{ fontSize: 14 + 'px', fontWeight: 700 }">
            </DataCard>
          </div>
        </section>

        <section class="data-section">
          <div class="section-title">
            <div class="section-title-left">
              <v-icon size="16" color="#FF9850">mdi-fire</v-icon>
              <span>消防</span>
            </div>
            <button type="button" class="section-more-btn" v-ripple="{ class: 'text-indigo-lighten-4' }"
              @click="openFireDetail()">
              详情
              <v-icon size="14" color="#4C7EFF">mdi-chevron-right</v-icon>
            </button>
          </div>
          <div class="section-grid">
            <DataCard class="kv-bg" :title="item.label" title-position="left" :value="item.value" :unit="item.unit"
              v-for="item in fireItems" :key="item.key" :value-style="{ fontSize: 14 + 'px', fontWeight: 700 }"
              v-show="!item.hidden"></DataCard>
          </div>
        </section>

        <section class="data-section">
          <div class="section-title">
            <div class="section-title-left">
              <v-icon size="16" color="#60CF87">mdi-battery-high</v-icon>
              <span>电池簇</span>
            </div>
            <button type="button" class="section-more-btn" v-ripple="{ class: 'text-indigo-lighten-4' }"
              @click="openClusterDetail(blockMeta)">
              详情
              <v-icon size="14" color="#4C7EFF">mdi-chevron-right</v-icon>
            </button>
          </div>
          <div class="section-grid">
            <DataCard class="kv-bg" :title="item.label" title-position="left" :value="item.value" :unit="item.unit"
              v-for="item in batteryItems" :key="item.key" :value-style="{ fontSize: 14 + 'px', fontWeight: 700 }">
            </DataCard>
          </div>
        </section>

        <section class="data-section">
          <div class="section-title">
            <div class="section-title-left">
              <v-icon size="16" color="#4C7EFF">mdi-air-conditioner</v-icon>
              <span>空调/水机</span>
            </div>
            <button type="button" class="section-more-btn" v-ripple="{ class: 'text-indigo-lighten-4' }"
              @click="openAirConditionDetail(blockMeta)">
              详情
              <v-icon size="14" color="#4C7EFF">mdi-chevron-right</v-icon>
            </button>
          </div>
          <div v-if="airTabs.length > 1" class="tabs">
            <button v-for="(tab, index) in airTabs" :key="tab" class="tab" :class="{ active: activeAirTab === tab }"
              @click="onAirTabClick(tab, index)">
              {{ tab }}
            </button>
          </div>
          <div class="section-grid">
            <DataCard class="kv-bg" :title="item.label" title-position="left" :value="item.value" :unit="item.unit"
              v-for="item in thermalItems" :key="item.key" :value-style="{ fontSize: 14 + 'px', fontWeight: 700 }">
            </DataCard>
          </div>
        </section>
      </div>
    </div>
  </div>


  <PcsDetailDialog v-model="pcsDetailDialogVisible" :block-data="currentPcsDetail" />
  <!-- Cluster 详情弹框 -->
  <ClusterDetailDialog v-model="clusterDetailDialogVisible" :cluster-data="currentClusterDetail"
    :eblock-id="currentClusterDetail?.eblock_id" />

  <!-- Pack 详情弹框 (新组件) -->
  <FirePackDetailDialog v-model="packDialogVisible" :block="detailData?.fire_sys" />

  <!-- 空调详情 -->
  <AirConditionDetailDialog v-model="airConditionDetailVisible" :stationId="route.query.stationId"
    :elinkUuid="currentDetailElinkUuid" :eblockUuid="currentDetailEblockUuid"
    :openAlarmHistory="openWithAlarmHistory" />
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ws_req } from '@/ws/wss-request'
import { useStationContext } from '../../../composables/useStationContext'
import {
  EBlockWorkStatus,
  FireProtectionHostStatus,
  AircStatus,
  appraiseFromSOH,
  formatStatus,
  getEBlockOnlineClass,
  getEBlockOnlineText,
  EBlockStatusColor
} from '../../../components/real-time-monitor/monitorEnums'

import blockMain172 from '@/assets/images/station-monitor/detail-dialog/block-main-172.png'
import blockMain200 from '@/assets/images/station-monitor/detail-dialog/block-main-200.png'
import blockMain230 from '@/assets/images/station-monitor/detail-dialog/block-main-230.png'
import blockMain250 from '@/assets/images/station-monitor/detail-dialog/block-main-250.png'
import blockMain261 from '@/assets/images/station-monitor/detail-dialog/block-main-261.png'
import blockMain372 from '@/assets/images/station-monitor/detail-dialog/block-main-372.png'
import blockMain836 from '@/assets/images/station-monitor/detail-dialog/block-main-836.png'

import PcsDetailDialog from '../../../components/real-time-monitor/PcsDetailDialog.vue'
// import ElinkDetailDialog from '../../../components/real-time-monitor/ElinkDetailDialog.vue'
// import EblockDetailDialog from '../../../components/real-time-monitor/EblockDetailDialog.vue'
import ClusterDetailDialog from '../../../components/real-time-monitor/ClusterDetailDialog.vue'
import FirePackDetailDialog from '../../../components/real-time-monitor/FirePackDetailDialog.vue'
// import FireChartDialog from '../../../components/real-time-monitor/FireChartDialog.vue'
import AirConditionDetailDialog from '../../../components/real-time-monitor/AirConditionDetailDialog.vue'

import DataCard from '@/components/DataCard/index.vue'
import BatteryIcon from './img/Battery.vue'
import { Siren, Wifi, WifiOff } from 'lucide-vue-next'
import { eui } from 'ems-ui'

const route = useRoute()
const router = useRouter()
const { stationId } = useStationContext()

const props = defineProps({
  arrayList: {
    type: Array,
    default: () => []
  },
  getEBlockById: {
    type: Function,
    default: () => { }
  }
})

const deviceUuid = computed(() => String(route.query.deviceId || '').trim())
const eBlock = computed(() => props.getEBlockById(deviceUuid.value))



function getProductIntroduce(productModel) {  
  return 'https://jdenergy.com/cn/products/#sort1'
}

function copyUuid(uuid) {
  if (uuid === undefined || uuid === null || uuid === '') return
  navigator.clipboard.writeText(String(uuid))
  eui.showToast('复制成功', 'success')
}

const blockMeta = computed(() => findBlockMeta())
const detailData = ref({})
const pollingTimer = ref(null)

const elinkId = computed(() => String(route.query.elinkId || '').trim())
const pcsDetailDialogVisible = ref(false)
const currentPcsDetail = ref(null)
function openPCSDetail() {
  // currentPcsDetail.value = block
  currentPcsDetail.value = {
    ...eBlock.value,
    // name: eBlock.value.eBlockName+'-PCS',
  }

  pcsDetailDialogVisible.value = true
}


const clusterDetailDialogVisible = ref(false)
const currentClusterDetail = ref(null)
function openClusterDetail(block) {
  if (block) {
    currentClusterDetail.value = { ...block, name: block.eblock_name + '-电池簇' }
  } else {
    currentClusterDetail.value = { ...eBlock.value, name: eBlock.value.eBlockName, eblock_id: eBlock.value.id }
  }
  clusterDetailDialogVisible.value = true
}

const packDialogVisible = ref(false)
// const currentBlock = ref(null)
function openFireDetail() {
  // currentBlock.value = block
  packDialogVisible.value = true
}

const airConditionDetailVisible = ref(false)
const currentDetailElinkUuid = ref(null)
const currentDetailEblockUuid = ref(null)
const openWithAlarmHistory = ref(false)

const findElinkIdByBlockId = (blockUuid) => {

  for (const array of props.arrayList) {
    if ((array.eBlockList || []).some(b => b.uuid === blockUuid)) {
      return array.eLink.uuid
    }
  }
  return null
}
function openAirConditionDetail(block) {
  let uuid = null
  if (block) {
    uuid = block.uuid
  } else {
    uuid = eBlock.value.uuid
  }

  currentDetailElinkUuid.value = findElinkIdByBlockId(uuid)
  currentDetailEblockUuid.value = uuid
  openWithAlarmHistory.value = false
  airConditionDetailVisible.value = true
}

const blockImageMap = {
  '172': blockMain172,
  '200': blockMain200,
  '230': blockMain230,
  '250': blockMain250,
  '261': blockMain261,
  '372': blockMain372,
  '836': blockMain836
}

const parseModelNumber = (model) => {
  const match = String(model || '').match(/\d+/)
  return match ? match[0] : '200'
}

const deviceImageSrc = computed(() => {
  const modelNumber = parseModelNumber(eBlock.value?.productModel ?? '')
  return blockImageMap[modelNumber] || blockMain200
})

const toDisplay = (value, unit = '') => {
  if (value === null || value === undefined || value === '') return '--'
  return `${value}${unit}`
}

const toFixedDisplay = (value, digits = 2, unit = '') => {
  if (value === null || value === undefined || value === '' || Number.isNaN(Number(value))) {
    return '--'
  }
  return `${Number(value).toFixed(digits)}${unit}`
}


const alarmStatus = computed(() => {
  const count = Number(detailData.value?.alarmNum ?? 0)
  if (count > 0) {
    return { text: `告警(${count})`, className: 'is-alarm' }
  }
  return { text: '正常', className: 'is-normal' }
})

const onlineStatus = computed(() => {
  const state = detailData.value?.online
  return {
    text: state ? '在线' : '离线',
    className: state ? 'online' : 'offline'
  }
})


function onBack() {
  router.back()
}

const PCSRunMode = {
  0x0000: '独立逆变',
  0x0001: '直流恒功率',
  0x0002: '交流恒功率',
  0x0003: '直流恒压',
  0x0004: '交流恒流',
  0x0005: 'SVG',
  0x0006: '交流恒压',
  0x0007: '老化模式',
  0x0008: '直流恒流'
}

const FireHostOnlineStatus = {
  0: '离线',
  1: '在线'
}

const FireCabinetAlarmLevel = {
  0: '正常',
  1: '一级预警',
  2: '二级预警',
  3: '三级预警'
}

const FireSensorBinary = {
  0: '正常',
  1: '告警'
}

const AirPowerSwitch = {
  0: '关机',
  1: '开机'
}

const AirUnitWorkStatus = {
  0: '关机',
  1: '送风',
  2: '制冷',
  3: '加热',
  4: '除湿'
}



// eBlock消防抑制剂液位状态
const FC_LEVEL_STATUS = {
  1: '液位正常',
  2: '液位低',
}

// eBlock消防喷洒状态
const FC_SPRAY_STATUS = {
  1: '未喷洒',
  2: '已喷洒',
}


const pickFirst = (...vals) => {
  for (const v of vals) {
    if (v !== undefined && v !== null && v !== '') return v
  }
  return undefined
}

const formatFireSensorStatus = (d) => {
  const v = pickFirst(d.sensor_st, d.smoke_st)
  if (v === undefined || v === null || v === '') return '--'
  return FireSensorBinary[v] || String(v)
}

const formatFireHostOnline = (d) => {
  const v = pickFirst(d.fire_hst_online, d.hst_online, d.fire_host_online)
  return formatStatus(v, FireProtectionHostStatus)
}

const formatCoConc = (d) => {
  const v = pickFirst(d?.co_conc, d?.co_density)
  return toFixedDisplay(v, 0)
}

const overviewItems = computed(() => [
  { key: 'workState', label: '工作状态', value: formatStatus(detailData.value?.eBlock?.eblock_run_st, EBlockWorkStatus) },
  // { key: 'airState', label: '空调状态', value: formatStatus(detailData.value?.aircondition?.telemeter?.work_state, AircStatus) },
  // { key: 'fireState', label: '消防状态', value: formatStatus(detailData.value?.fire_sys?.fire_hst_st, FireProtectionHostStatus) },
  { key: 'power', label: '实时功率', value: toFixedDisplay(detailData.value?.pcs?.p, 2, 'kW') },
  { key: 'soc', label: 'SOC', value: toFixedDisplay(detailData.value?.eBlock?.soc, 2, '%') },
  { key: 'soh', label: 'SOH', value: appraiseFromSOH(detailData.value?.eBlock?.soh) },
  { key: 'remain', label: '电池剩余电量', value: toFixedDisplay(detailData.value?.eBlock?.e_dischargeable, 2, 'kWh') },
])


const PCSRunState = {
  0: '停机',
  1: '自检',
  2: '待机',
  3: '并网',
  4: '故障',
}
const pcsItems = computed(() => [
  { key: 'workState', label: 'PCS运行状态', value: formatStatus(detailData.value?.pcs?.pcs_run_st, PCSRunState) },
  { key: 'activePower', label: '有功功率', value: toFixedDisplay(detailData.value?.pcs?.p, 2), unit: 'kW' },
  { key: 'ambientTemp', label: '机箱内温度', value: toFixedDisplay(detailData.value?.pcs?.temp_chassis, 2), unit: '℃' },
  { key: 'runMode', label: 'PCS运行模式', value: formatStatus(detailData.value?.pcs?.pcs_run_mode, PCSRunMode) },
  { key: 'reactivePower', label: '无功功率', value: toFixedDisplay(detailData.value?.pcs?.q, 2), unit: 'kVar' },
  // { key: 'innerTemp', label: '机箱内温度', value: toFixedDisplay(detailData.value?.pcs?.temp_inner, 2, '℃') },
  { key: 'insulation', label: '对地绝缘阻抗', value: toFixedDisplay(detailData.value?.eBlock?.r_insulation, 2), unit: 'KΩ' }
])

const batteryItems = computed(() => {
  const d = detailData.value.eBlock ?? {}
  const uCellMax = Number(d.u_cell_max || 0)
  const uCellMin = Number(d.u_cell_min || 0)
  const tempMax = Number(d.temp_cell_max || 0)
  const tempMin = Number(d.temp_cell_min || 0)
  const uDiff =
    d.u_cell_diff !== undefined && d.u_cell_diff !== null && d.u_cell_diff !== ''
      ? Number(d.u_cell_diff)
      : uCellMax - uCellMin
  const tDiff =
    d.temp_cell_diff !== undefined && d.temp_cell_diff !== null && d.temp_cell_diff !== ''
      ? Number(d.temp_cell_diff)
      : tempMax - tempMin
  return [
    { key: 'chargeLimit', label: '允许最大充电功率', value: toFixedDisplay(d.p_ch_max, 2), unit: 'kW' },
    { key: 'dischargeLimit', label: '允许最大放电功率', value: toFixedDisplay(d.p_disch_max, 2), unit: 'kW' },
    { key: 'uCellMax', label: '最高电芯电压', value: toFixedDisplay(d.u_cell_max, 2), unit: 'mV' },
    { key: 'uCellMin', label: '最低电芯电压', value: toFixedDisplay(d.u_cell_min, 2), unit: 'mV' },
    { key: 'uCellDiff', label: '电芯最高压差', value: toFixedDisplay(uDiff, 2), unit: 'mV' },
    { key: 'tempMax', label: '最高电芯温度', value: toFixedDisplay(d.temp_cell_max, 2), unit: '℃' },
    { key: 'tempMin', label: '最低电芯温度', value: toFixedDisplay(d.temp_cell_min, 2), unit: '℃' },
    { key: 'tempDiff', label: '电芯最高温差', value: toFixedDisplay(tDiff, 2), unit: '℃' }
  ]
})

const fireItems = computed(() => {
  const d = detailData.value.fire_sys ?? {}
  const eb = detailData.value.eBlock ?? {}
  return [
    // { key: 'sensor', label: '传感器状态', value: formatFireSensorStatus(d) },
    { key: 'fc_host_status', label: '消防主机状态', value: FireProtectionHostStatus[eb.fc_host_status] },
    { key: 'fc_level_status', label: 'eBlock消防抑制剂液位状态', value: formatStatus(eb.fc_level_status, FC_LEVEL_STATUS), hidden: !eb.fc_host_status || eb.fc_host_status == 3 },
    { key: 'fc_spray_status', label: 'eBlock消防喷洒状态', value: formatStatus(eb.fc_spray_status, FC_SPRAY_STATUS), hidden: !eb.fc_host_status || eb.fc_host_status == 3 },
    { key: 'cabinetTemp', label: '柜体温度', value: toFixedDisplay(eb.temp_cabinet, 2), unit: '℃' },
    { key: 'cabinetHumidity', label: '柜体湿度', value: toFixedDisplay(eb.hum_cabinet, 2), unit: '%' },
    { key: 'co', label: 'CO浓度', value: formatCoConc(d.matrix), unit: 'ppm', hidden: !eb.fc_host_status },
    { key: 'cabinetFireLevel', label: '柜体消防预警级别', value: formatStatus(d.matrix?.alarm_level, FireCabinetAlarmLevel), hidden: !eb.fc_host_status },
  ]
})


const airIndex = ref(0)
const airTabs = computed(() => {
  const aircond = detailData.value.aircondition?.aircond ?? []
  return aircond.map((_, index) => `${index + 1}#空调`)
})
const activeAirTab = ref('')

watch(
  airTabs,
  (tabs) => {
    if (!tabs.length) {
      activeAirTab.value = ''
      airIndex.value = 0
      return
    }
    if (airIndex.value >= tabs.length) {
      airIndex.value = tabs.length - 1
    }
    const current = activeAirTab.value
    if (current && tabs.includes(current)) {
      airIndex.value = tabs.indexOf(current)
      return
    }
    activeAirTab.value = tabs[airIndex.value] ?? tabs[0]
    airIndex.value = tabs.indexOf(activeAirTab.value)
  },
  { immediate: true }
)

function onAirTabClick(tab, index) {
  activeAirTab.value = tab
  airIndex.value = index
}
const thermalItems = computed(() => {
  const aircond = detailData.value.aircondition?.aircond ?? []
  const d = aircond[airIndex.value] ?? {}
  const onOff = pickFirst(d?.telemeter?.on_off)
  const workState = pickFirst(d?.telemeter?.work_state)

  return [
    { key: 'powerSwitch', label: '开关机状态', value: formatStatus(onOff, AirPowerSwitch) },
    // { key: 'airState', label: '空调状态', value: formatStatus(d.airc_st, AircStatus) },
    { key: 'unitState', label: '空调机组状态', value: formatStatus(workState, AirUnitWorkStatus) },
    { key: 'evaporatorTemp', label: '空调蒸发器温度', value: toFixedDisplay(d?.telemeter?.evaporator_temp, 2), unit: '℃' },
    { key: 'condenserTemp', label: '空调冷凝器温度', value: toFixedDisplay(d?.telemeter?.condenser_temp, 2), unit: '℃' },
    { key: 'humidity', label: '湿度', value: toFixedDisplay(d?.telemeter?.humity, 2), unit: '%' },
    { key: 'returnTemp', label: '回风温度', value: toFixedDisplay(d?.telemeter?.cabinet_in_temp, 2), unit: '℃' }
  ]
})

const resolveStationId = () => Number(route.query.stationId || stationId.value || 0)



function findBlockMeta() {
  for (const item of props.arrayList) {
    const target = (item.eBlockList || []).find(
      (block) => String(block.uuid || '').toLowerCase() === deviceUuid.value.toLowerCase()
    )
    return target
  }
  return {}
}

const fetchDetail = async () => {
  const currentStationId = resolveStationId()
  // const currentBlockId = eBlock.value.id
  if (!currentStationId) return

  try {
    const result = await ws_req.request('eblock_realtime_data', {
      eBlockUuid: deviceUuid.value,
      stationId: currentStationId,
      eLinkUuid: elinkId.value
    })

    console.log('---->', result, deviceUuid);

    if (result) {
      detailData.value = result
    }
  } catch (error) {
    console.error('获取 eBlock 详情失败:', error)
  }
}

const refreshData = async () => {
  // await fetchBlockMeta()
  await fetchDetail()
}

const startPolling = () => {
  stopPolling()
  refreshData()
  pollingTimer.value = setInterval(refreshData, 5000)
}


watch(() => deviceUuid.value, (uuid) => {
  if (uuid) {
    refreshData()
  }
})

const stopPolling = () => {
  if (pollingTimer.value) {
    clearInterval(pollingTimer.value)
    pollingTimer.value = null
  }
}

onMounted(() => {
  startPolling()
})

onUnmounted(() => {
  stopPolling()
})
</script>

<style scoped lang="scss">
.device-detail-page {
  // padding: 18px;
  background: #f7f9fc;
  border-radius: 20px;

}

.overview-card {
  display: grid;
  // grid-template-columns: 240px 1fr;
  gap: 20px;
  padding: 18px 20px;
  border-radius: 20px;
  background: #fff;
  border: 1px solid #ecf1f8;
  margin-bottom: 16px;
}

.overview-left {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.overview-right {
  min-width: 0;
}

.header-card {
  background: #fff;
  border-radius: 14px;
  padding: 2px 0 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  min-width: 0;
  display: flex;
  align-items: center;
}

.header-main {
  margin-left: 14px;
  min-width: 0;
}

.device-name {
  font-size: 20px;
  line-height: 36px;
  font-weight: 600;
  color: #1f2329;
  margin-bottom: 8px;
}

.meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  color: #747f92;
  font-size: 14px;
  line-height: 18px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 22px;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.status-label {
  color: #1f2329;
  font-size: 13px;
}

.status-text {
  color: #1f2329;
  font-size: 13px;
}

.status-alarm {}

.status-alarm.is-normal {
  color: #19b45b;
  border: 1px solid #61b184 !important;
}

.status-alarm.is-alarm {
  color: #ff4d4f;
  border: 1px solid #ff4d4f !important;
}

.status-pill {}

.status-pill.online {
  color: #1d4ed8;
  border: 1px solid #9ab5ff !important;
}

.status-pill.offline {
  color: #6b7280;
  border: 1px solid #bbc8dd !important;
}

.device-image-wrap {
  margin-top: 16px;
  width: 420px;
  // height: 100%;
  min-height: 220px;
  border-radius: 12px;
  background: radial-gradient(60% 60% at 50% 58%, rgba(107, 136, 255, 0.08) 0%, rgba(255, 255, 255, 0) 100%);
  // display: flex;
  // align-items: center;
  // justify-content: center;
  position: sticky;
  top: 16px;
  text-align: center;
}

.device-image {
  // width: 180px;
  // max-height: 260px;
  width: 100%;
  object-fit: contain;
  max-width: 300px;

}

.overview-section {
  margin-top: 6px;
  border: none !important;
  border-radius: 0 !important;
  overflow: hidden;
}

.data-section {
  border-radius: 16px;
  border: 1px solid #edf2f8;
  background: #fff;
  overflow: hidden;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  color: #1f2329;
  font-weight: 500;
  background: #fff linear-gradient(109.37deg, rgba(231, 237, 255, 0.55) 1.53%, rgba(255, 255, 255, 0.6) 98.28%);
  padding: 8px 12px;
  border-bottom: 1px solid #eff3f9;
}

.section-title-left {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.section-more-btn {
  border: none;
  background: transparent;
  color: #4c7eff;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 14px;
  line-height: 18px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 3px;
}

.tabs {
  padding: 12px 12px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tab {
  border: 1px solid #deebff;
  border-radius: 14px;
  background: #f5f8ff;
  color: #6c7a91;
  padding: 2px 10px;
  font-size: 13px;
  cursor: pointer;
}

.tab.active {
  color: #fff;
  background: #3563ff;
  border-color: #3563ff;
}

.overview-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  margin-top: 16px;
  // padding: 14px 14px 16px;
}

.overview-kv {
  min-height: 74px;
  border-radius: 12px;
  border: 1px solid #edf2f7;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.overview-power {
  background: linear-gradient(90deg, #f7fbff 0%, #ffffff 100%);
}

.overview-soc {
  background: linear-gradient(90deg, #fff7f7 0%, #ffffff 100%);
}

.overview-remain {
  background: linear-gradient(90deg, #f6fff9 0%, #ffffff 100%);
}

.overview-label {
  font-size: 13px;
  color: #7d8a9e;
}

.overview-value {
  font-size: 26px;
  line-height: 30px;
  color: #1f2329;
  font-weight: 600;
}

.section-matrix {
  flex: 1;
  display: grid;
  // grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.section-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 12px;
  padding: 12px;
}

.kv-item {
  background: #f5f7fb;
  border-radius: 8px;
  min-height: 38px;
  padding: 8px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.kv-bg {
  background: #F6F9FC;
}

.kv-item.hidden {
  display: none;
}

.kv-label {
  font-size: 13px;
  color: #6d7a91;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.kv-value {
  font-size: 14px;
  color: #1f2329;
  font-weight: 600;
  white-space: nowrap;
}

.back-btn {
  width: 98px;
  height: 40px;
  border-radius: 12px;
  border: 1px solid #C0CFDA;
  margin-right: 10px;
  margin-left: -10px;
}

@media (max-width: 1600px) {
  .overview-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 1366px) {
  .overview-card {
    grid-template-columns: 1fr;
  }

  .overview-left {
    display: none;
  }

  .section-matrix {
    grid-template-columns: 1fr;
  }
}

.blue-bg {
  background: linear-gradient(132.97deg, #E7F3FF 1.64%, rgba(255, 255, 255, 0.7) 73.78%);
}

.red-bg {
  background: linear-gradient(132.97deg, #FFE7E7 1.64%, rgba(255, 255, 255, 0.7) 73.78%);
}

.green-bg {
  background: linear-gradient(132.97deg, #E7FFE7 1.64%, rgba(255, 255, 255, 0.7) 73.78%);
}

.blue-border {
  border: 1px solid #E7F3FF;
}

.red-border {
  border: 1px solid #FFE7E7;
}

.green-border {
  border: 1px solid #E4FAE2;
}
</style>
